import styled from 'styled-components';
export const FixedHeaderFooterContainer = styled('div') `
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;
export const FixedHeaderFooterHeader = styled('div') `
    position: relative;
    flex-shrink: 0;
`;
export const FixedHeaderFooterBody = styled('div') `
    position: relative;
    flex-grow: 1;
    overflow: auto;
`;
export const FixedHeaderFooterFooter = styled('div') `
    position: relative;
    flex-shrink: 0;
`;
//# sourceMappingURL=FixedHeaderFooterLayout.Styled.js.map